/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex-direction:column;box-sizing:border-box;display:flex;align-content:stretch;justify-content:flex-start;align-items:stretch;color:#41413f}"];
export { styles as styles };
